import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AdminPortalShieldIcon } from "@components/common/Icons/AdminPortalShieldIcon";
import type { RootState } from "@store/store";
import { getUserDisplayLabel } from "@utils/getUserDisplayLabel";
import { isCmAdminUser } from "@features/CmDashboard/cmAdmin";

export const HeaderBranding: React.FC = () => {
	const { t } = useTranslation();
	const user = useSelector((state: RootState) => state.user.user);

	const portalTitle = useMemo(() => {
		if (isCmAdminUser(user)) return "CM DASHBOARD";
		return `${getUserDisplayLabel(user, t("components.dashboard.welcomeFallback"))} Portal`;
	}, [user, t]);

	return (
		<div className="header-branding flex min-w-0 items-center">
			<AdminPortalShieldIcon className="header-branding__icon shrink-0" />
			<h1 id="project-title" className="header-branding__title truncate font-sans">
				{portalTitle}
			</h1>
		</div>
	);
};
